<template>
    <div id="app">

        <keep-alive>
            <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>


    </div>
</template>

<script type="text/ecmascript-6">

    export default {
        name: 'app',
        data() {
            return {
            }
        },
        computed: {
        },
        mounted: function () {
            let self = this
        },
        methods: {

        }
    }
</script>



// WEBPACK FOOTER //
// src/App.vue